	<template>
		<div class="check-commercial-access" :set="access = $nikan.checkCommercialAccessDetailed(commercialAccess)">
			<div class="no-permission" v-if="!access.value" :style="{ position: coverParent ? 'absolute' : 'Fixed' }" startup>
				<div class="nk-card d-flex align-items-center flex-column">
					<img src="@/assets/access-denied.svg" alt="Access Denied">
					<h5>{{ access.message }}</h5>
					<nk-button v-if="access.type === 'NotPurchased'" class="w-50" :options="componentOptions.upgradePlan" @click="upgradePlan"></nk-button>
					<nk-button v-if="access.type === 'Expired'" class="w-50" :options="componentOptions.reNewPlan" @click="reNewPlan"></nk-button>
				</div>
			</div>
		</div>
	</template>

<script>
	import $ from 'jquery'
	import _ from 'lodash'
	import $sc from '~/plugins/shortcut.collection.js'
	export default {
		props: {
			commercialAccess: { type: [String, Function, Array], default: '' },
			coverParent: { type: Boolean, default: false }
		},
		data() {
			return {
				componentOptions: {
					upgradePlan: {
						title: this.$t('home.widgets.bussiness-plan.plan-upgrade'),
						shortcut: $sc.find('new'),
						isPrimary: true,
						hideIcon: true,
						handle: (button, page, e) => this.upgradePlan,
					},
					reNewPlan: {
						title: this.$t('home.widgets.bussiness-plan.plan-renew'),
						shortcut: $sc.find('new'),
						isPrimary: true,
						hideIcon: false,
						handle: (button, page, e) => this.reNewPlan,
					}
				}
			}
		},
		mounted() {
			if (!this.$nikan.checkCommercialAccess(this.commercialAccess)) {
				this.$emit('restricted-access')
				this.removeScroll()
			}
		},
		methods: {
			upgradePlan() {
				window.open(import.meta.env.VITE_UPGRADE_PLAN_ENDPOINT, '_blank')
			},
			reNewPlan() {
				window.open(import.meta.env.VITE_RENEW_PLAN_ENDPOINT, '_blank')
			},
			removeScroll() {
				this.defer(() => {
					$('.no-permission').closest('.grid-stack-item-content').css('overflow-y', 'hidden')
					$('.no-permission').closest('.grid-stack-item-content').css('z-index', 0)
					$('.nk-page-body').attr('style', 'overflow-y: hidden !important')
				}, 100)
			}
		},
	}
</script>
<style>
	.check-commercial-access .nk-card {
		max-height: 300px;
		max-width: 300px;
		height: 100%;
		width: 100%;
		margin: auto;
		text-align: center;
		box-shadow: 0px 2px 3px 1px #a6a6a6;
		border: 2px solid #716aca;
		border-radius: 15px;
	}

	.check-commercial-access img {
		max-height: 200px;
		max-width: 150px;
		width: 100%;
		height: 100%;
		align-self: center;
	}

	.nm-body .check-commercial-access .no-permission {
		top: 49px !important;
	}
</style>